<template>
  <div class="d-flex-column justify-start align-start gap-24 mt-20">
    <GamePackBanner />

    <div
      class="d-flex-row align-start space-between xl-row-to-col gap-24 mobile-min-height"
    >
      <div class="d-flex-row flex-15 t-white" style="min-height: 48px">
        <div class="d-flex-column justify-start align-start gap-16">
          <LazyCustomSeasonLengthNew
            v-if="showSeasonLength"
            :season-length="getGame?.game_season"
          />
          <PackSelector />
        </div>
      </div>
      <!-- PACKS HERE -->
      <div
        class="d-flex-column flex-65 justify-start align-start t-white gap-24"
      >
        <!-- <div class="warning_message d-flex-row justify-start" v-if="isFaceit">
          <img
            src="/images/icons/warning-icon.webp"
            alt="warning_icon"
            height="30"
            width="30"
          />
          <p class="t-white font-family-2 medium-m">
            {{ $t("app.no_drops_elo") }}
          </p>
        </div> -->
        <PremierBoost
          v-if="currentGamePackSlug === 'counter-strike-2-rank-boost'"
        />
        <CompetitiveWins
          v-else-if="
            currentGamePackSlug === 'counter-strike-2-ranked-win-boost'
          "
        />
        <FaceitDivisionBoosting
          v-else-if="
            currentGamePackSlug === 'counter-strike-2-faceit-division-boosting'
          "
        />
        <FaceitRankBoosting
          v-else-if="
            currentGamePackSlug === 'counter-strike-2-faceit-rank-boosting'
          "
        />
        <FaceitWins
          v-else-if="
            currentGamePackSlug === 'counter-strike-2-faceit-win-boosting'
          "
        />
        <FaceitPlacement
          v-else-if="
            currentGamePackSlug ===
            'counter-strike-2-faceit-placements-boosting'
          "
        />
        <!-- LARGE FAQS -->
        <div class="d-flex-column justify-start xl-hide" v-if="getPackFaq">
          <p
            class="t-orange regular-l f-w-500 font-family-1"
            style="letter-spacing: 2px"
          >
            {{ $t("homepage.faq") }}s
          </p>
          <Faq :faqs="getPackFaq" variant="pack" />
        </div>
      </div>
      <!-- CART HERE -->
      <div
        class="d-flex-column flex-2 justify-start align-start t-white cart_container"
      >
        <WhyWeCheap />
        <Cart />
        <SafeSecurePayments />

        <div
          class="d-flex-column justify-start above-xl-hide"
          v-if="getPackFaq"
          style="margin-top: 24px"
        >
          <p
            class="t-orange regular-l f-w-500 font-family-1"
            style="letter-spacing: 2px"
          >
            {{ $t("homepage.faq") }}s
          </p>
          <Faq :faqs="getPackFaq" variant="pack" />
        </div>
      </div>
    </div>
    <PackOptimalText />
  </div>
</template>

<script setup>
import GamePackBanner from "~/components/banners/GamePackBanner.vue";
import PackSelector from "~/components/common/sections/boosting/PackSelector.vue";
import Faq from "~/components/custom/Faq.vue";
import PackOptimalText from "~/components/common/PackOptimalText.vue";
import Cart from "~/components/calculators/checkout/Cart.vue";
import SafeSecurePayments from "~/components/calculators/checkout/SafeSecurePayments.vue";
import PremierBoost from "~/components/calculators/counterstrike2/PremierBoost.vue";
import CompetitiveWins from "~/components/calculators/counterstrike2/CompetitiveWins.vue";
import FaceitDivisionBoosting from "~/components/calculators/counterstrike2/FaceitDivisionBoosting.vue";
import FaceitRankBoosting from "~/components/calculators/counterstrike2/FaceitRankBoosting.vue";
import FaceitWins from "~/components/calculators/counterstrike2/FaceitWins.vue";
import FaceitPlacement from "~/components/calculators/counterstrike2/FaceitPlacement.vue";
import { computed } from "vue";
import SeasonLength from "~/components/custom/SeasonLength.vue";
import WhyWeCheap from "~/components/custom/WhyWeCheap.vue";

const { getGamePack, getGame } = useGameStore();
const { currentGamePackSlug } = useGameComposable();

const getPackFaq = computed(() => {
  if (getGamePack?.faqs) {
    return getGamePack?.faqs;
  }

  return null;
});

const isFaceit = computed(() => {
  if (
    [
      "counter-strike-2-faceit-division-boosting",
      "counter-strike-2-faceit-rank-boosting",
      "counter-strike-2-faceit-win-boosting",
      "counter-strike-2-faceit-placements-boosting",
    ].includes(currentGamePackSlug)
  ) {
    return true;
  }
  return false;
});

const showSeasonLength = computed(() => {
  if (!getGame?.id) return false;
  if (getGame?.game_season?.id) return true;
  return false;
});
</script>
